module.exports = __webpack_public_path__ + "static/media/lasso.d8d7f785.svg";